import React from 'react'
import { useWindowSize } from 'react-use'

import { ReactComponent as RotationIcon } from 'assets/uiIcons/rotation-icon.svg'

import { Root } from './LandscapeModal.styled.js'

const LandscapeModal = () => {
  const { width, height } = useWindowSize()

  const orientation = width > height ? 'landscape' : 'portrait'
  const smallScreen = width <= 786
  const orientationLock = smallScreen && orientation === 'landscape'

  //return (
    //<Root show={orientationLock}>
      //<RotationIcon></RotationIcon>
    //</Root>
  //)
}

export default LandscapeModal
